import { Link, useLocation } from "react-router";

interface SidebarGroupItemProps {
  title: string;
  icon: React.ReactNode;
  subMenuItems: { href: string; label: string }[];
}

export function SidebarGroupItem({
  title,
  icon,
  subMenuItems,
}: SidebarGroupItemProps) {
  const location = useLocation();
  const url = location.pathname;

  return (
    <div
      className={`menu-item ${
        subMenuItems.some((item) => item.href === url) ? "show" : ""
      }`}
      data-menu-item-toggle="accordion"
      data-menu-item-trigger="click"
    >
      <div className="menu-link gap-2.5 py-2 px-2.5 rounded-md border border-transparent">
        <span className="menu-icon items-start text-gray-600 text-lg menu-item-here:text-gray-800 menu-item-show:text-gray-800 menu-link-hover:text-gray-800 dark:menu-item-here:text-gray-900 dark:menu-item-show:text-gray-900 dark:menu-link-hover:text-gray-900">
          {icon}
        </span>
        <span className="menu-title font-medium text-sm text-gray-800 menu-item-here:text-gray-900 menu-item-show:text-gray-900 menu-link-hover:text-gray-900">
          {title}
        </span>
        <span className="menu-arrow text-gray-600 menu-item-here:text-gray-800 menu-item-show:text-gray-800 menu-link-hover:text-gray-800">
          <i className="ki-filled ki-down text-xs menu-item-show:hidden"></i>
          <i className="ki-filled ki-up text-xs hidden menu-item-show:inline-flex"></i>
        </span>
      </div>
      <div className="menu-accordion gap-px ps-7">
        {subMenuItems.map(({ href, label }) => (
          <div
            className={url === href ? "menu-item active" : "menu-item"}
            key={href + label}
          >
            <Link
              to={href}
              className="menu-link py-2 px-2.5 rounded-md border border-transparent menu-item-active:border-gray-200 menu-item-active:bg-light menu-link-hover:bg-light menu-link-hover:border-gray-200"
            >
              <span className="menu-title text-2sm text-gray-800 menu-item-active:text-gray-900 menu-link-hover:text-gray-900">
                {label}
              </span>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
